<template>
  <div
    class="boss-layout-block boss-message-mail-body pega-pre-wrap"
    v-html="$sanitize(renderBody)"
  />
</template>

<script>
import util from '@/lib/util.js'

export default {
  props: {
    body: {
      type: String,
      default: ''
    }
  },
  computed: {
    renderBody () {
      return util.replaceAddressAndUrlLink(this.body)
    }
  }
}
</script>
